<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!--        <div v-if="$gate.isBranchManager()">-->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-md-10">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Give To Branch:</span>
                            <v-select v-model="source_branch" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select to branch" label="fullname" @input="getWarehouses"></v-select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Give To Warehouse:</span>
                            <input class="form-control" type="text" v-model="source_warehouse" value="GD" name="GD" readonly>
<!--                            <v-select v-model="source_warehouse" :options="branch_warehouses" :reduce="branch_warehouses => branch_warehouses.type" placeholder="Select source warehouse" label="name"></v-select>-->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Give From Branch:</span>
                            <v-select v-model="destination_branch" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select from branch" label="fullname" @input="getWarehouses"></v-select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Give from From Warehouse:</span>
                            <input class="form-control" type="text" v-model="destination_warehouse" value="GD" name="GD" readonly>
<!--                            <v-select v-model="destination_warehouse" :options="warehouses" :reduce="warehouses => warehouses.type" placeholder="Select destination warehouse" label="name"></v-select>-->
                        </div>
                    </div>
                </div>
            </div>
        <br><br>
				<div class="col-md-10">
                    <div class="row">
                        <div class="card card-danger card-outline" style="width:100% !important;">
                            <div class="card-body">
                                <!--						<div class="col-md-12" v-for="(item, index) in items">-->
                                <!--							<div class="row">-->
                                <!--								<div class="col-md-9">-->
                                <!--									item, {{index}}-->
                                <!--								</div>-->
                                <!--								<div class="col-md-3 center center-block" align="center">-->

                                <!--								</div>-->
                                <!--								<div class="col-md-2">-->

                                <!--								</div>-->
                                <!--							</div>-->
                                <div class="row">
                                    <table class="table thead-dark table-striped" style="width: 100%">
                                        <colgroup>
                                            <col span="1" style="width: 5%;">
                                            <col span="1" style="width: 10%;">
                                            <col span="1" style="width: 40%;">
                                            <col span="1" style="width: 10%;">
                                            <col span="1" style="width: 10%;">
                                            <col span="1" style="width: 20%;">
                                            <col span="1" style="width: 5%;">
                                        </colgroup>
                                        <thead class="thead-dark">
                                        <th><b>No.</b></th>
                                        <th><b>Item Code</b></th>
                                        <th><b>Item Name</b></th>
                                        <th><b>Quantity</b></th>
                                        <th><b>Price</b></th>
                                        <th><b>Notes</b></th>
                                        <th><i class="fa fa-cog"></i></th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in items">
                                            <td>{{index}}</td>
                                            <td>{{item.ItemCode}}</td>
                                            <td>{{item.ItemName}}</td>
                                            <td><div class="row">
<!--                                                <div class="col-md-3">-->
<!--                                                    <button class="btn btn-success fa fa-plus" @click="increment(index)"></button>-->
<!--                                                </div>-->
<!--                                                <div class="col-md-2">-->
                                                    <input type="number" min="1" v-model="item.RequestedQuantity">
<!--                                                </div>-->
<!--                                                <div class="col-md-3">-->
<!--                                                    <button class="btn btn-danger fa fa-minus" @click="decrement(index)"></button>-->
<!--                                                </div>-->
                                            </div></td>
                                            <td><p>{{item.Price}}</p></td>
                                            <td><input type="text" v-model="items[index].Notes" placeholder="Enter notes"></td>
                                            <td>
                                                <p><button @click="deleteTransferItem(index)" class="btn btn-danger"><i class="fa fa-trash"></i></button></p>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button class="btn btn-danger" style="width:100% !important;" @click="addPrompt"><i class="fa fa-plus"></i> Add Item</button>
                            </div>
                        </div>
                    </div>
                </div>
        <br><br>
                <div class="col-md-10">
                    <div class="row">
                        <div class="col-md-6">
                            <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes">
                        </div>
                        <div class="col-md-6">
                            <button style="width:100% !important;"  class="btn btn-danger" @click="requestTransfer">Make Stock Transfer</button>
                        </div>
                    </div>
                </div>
        <br><br><br><br><br><br><br>

    </section>
    <!-- /.content -->

	<div class="modal" tabindex="-1" role="dialog" id="searchModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Search Using Item Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="col-sm-12">
						<div class="row">
							<div class="col-sm-12">
               		<div class="row">
                      <div class="col-sm-6">

								         <div class="form-group">
								         	<input type="text" placeholder="Enter the itemcode" v-model="params[0].itemcode" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the item name" v-model="params[0].itemname" class="form-control">
								         </div>
                          <div class="form-group">
                              <input type="text" placeholder="Enter the brand" v-model="params[0].brand" class="form-control">
                          </div>
                          <div class="form-group">
                              <input type="text" placeholder="Enter the product name" v-model="params[0].productname" class="form-control">
                          </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the item classification type" v-model="params[0].itemclassificationtype" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the item classification value" v-model="params[0].itemclassificationvalue" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the camera" v-model="params[0].camera" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the capacity" v-model="params[0].capacity" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the colour" v-model="params[0].colour" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the cpu" v-model="params[0].cpu" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the goods/service type" v-model="params[0].goods" class="form-control">
								         </div>
                                    </div>
                                    <div class="col-sm-6">
                                         <div class="form-group">
								         	<input type="text" placeholder="Enter the input/output/consumption" v-model="params[0].consumption" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the no. of kf" v-model="params[0].noofkf" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the os" v-model="params[0].os" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the processor" v-model="params[0].processor" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the RAM/Storage" v-model="params[0].ram" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the rating" v-model="params[0].rating" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the screen size" v-model="params[0].screensize" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the type/series" v-model="params[0].type" class="form-control">
								         </div>
								         <div class="form-group">
								         	<input type="text" placeholder="Enter the resolution" v-model="params[0].resolution" class="form-control">
								         </div>
                                    </div>
                                </div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="itemSearch">Search ERP for Item <span class="right badge badge-success">{{search_status}}</span> </button>
								</div>
							</div>
							<br>
						</div>
						</div>
					</div>
				</div>
				</div>
				</div>

<div class="modal fade" id="searchitemsmodal" tabindex="-1" role="dialog" aria-labelledby="searchitemsmodal" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="searchitemsmodal">Pick Item</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<div class="overflow-auto" style="height: 400px;">
        <table class="table table-striped table-hover">
										<thead class="thead-dark" style="position: sticky;top: 0">
												<tr>
														<th class="header" scope="col">Item Code</th>
														<th class="header" scope="col">Item Name</th>
														<th class="header" scope="col">Select</th>
												</tr>
										</thead>
										<tbody>
												<tr v-for="(i, index) in search_items">
														<td>{{i.ItemCode}}</td>
														<th scope="row">{{i.Brand}}
														<br>
														{{ i.ItemGroupName }}
														<br>
														{{ i.Product }}
														<br>
														{{i.ItemName}} / {{i.Colour}}
														</th>
														<td><button class="btn btn-primary" @click="SAPItemCodeSearch(i.ItemCode)">Select</button></td>
												</tr>
										</tbody>
								</table>
								</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="icantthinkofaname" aria-hidden="true" id="icantthinkofaname">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="icantthinkofaname">Pick Item</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<div class="overflow-auto" style="height: 400px;">
        <table class="table table-striped table-hover">
										<thead class="thead-dark" style="position: sticky;top: 0">
												<tr>
														<th class="header" scope="col">Item Code</th>
														<th class="header" scope="col">Item Name</th>
														<th class="header" scope="col">TaxRate</th>
														<th class="header" scope="col">Price</th>
														<th class="header" scope="col">Select</th>
												</tr>
										</thead>
										<tbody>
												<tr v-for="i in SAPItems">
														<th scope="row">{{i.ItemCode}}</th>
														<th scope="row">{{i.ItemName}}</th>
														<td>{{i.TaxRate}}</td>
														<td><p>{{i.Price}}</p></td>
														<td><button class="btn btn-primary" @click="addItem(i)">Select</button></td>
												</tr>
										</tbody>
								</table>
								</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
<!-- All VUE Parts end before this comment -->
<!--        </div>-->
<!--        <div v-if="!$gate.isBranchManager()">-->
<!--             <access-denied></access-denied>-->
<!--        </div>-->
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getBranches();
        	this.getBranchWarehouses();
        },

        data(){
        	return{
        		branches: [],
        		items: [],
        		params: [{
		      		productname: "",
							brand: "",
							itemname: "",
              itemgroupname: "",
              product: "",
              itemcode: "",
							itemclassificationtype: "",
							itemclassificationvalue: "",
							camera: "",
							capacity: "",
							category: "",
							classification: "",
							colour: "",
							cpu: "",
							goods: "",
							consumption: "",
							noofkf: "",
							os: "",
							processor: "",
							ram: "",
							rating: "",
							screensize: "",
							type: "",
							resolution: ""
						}],
						search_status: '',
						search_items: [],
						destination_branch: '',
						RequestedQuantity: '',
						warehouses: [],
						branch_warehouses: [],
						destination_warehouse: 'GD',
						source_warehouse: 'GD',
                source_branch: '',
						SAPItems: [],
						notes: ''
        	}
        },

        methods: {
            getBranches(){
                axios.post("/api/getGodowns")
                    .then(response => {
                        this.branches = response.data;
                    })
            },

        	getWarehouses(){
        		axios.post("/api/getBranchWarehouses", {branch: this.destination_branch})
        		.then(response => {
        			this.warehouses = response.data;
        		});
        	},

        	getBranchWarehouses(){
        		axios.post("/api/getBranchWarehouses")
        		.then(response => {
        			this.branch_warehouses = response.data;
        		})
        	},

        	itemSearch(){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		this.lshow = true;
        		this.llabel = this.search_status;
        		axios.post("/api/getSAPItemList", {params: this.params})
        		.then(response => {
        			this.search_items = response.data;
        			toast.fire({
        				icon: "success",
        				title: "Search Complete"
        			});
              this.lshow = false;
        			this.search_status = 'Search Complete!';
        			if(this.search_items.length > 0){
        				//console.log(0);
        				$("#searchitemsmodal").modal("show");
        				$("#searchModal").modal("hide");
        			}
        		})
        		.catch((error) => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
              this.lshow = false;
        			this.search_status = 'Search Complete!';
        		})
        	},

        	SAPItemCodeSearch(code){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		this.lshow = true;
        		this.llabel = this.search_status;
        		axios.post("/api/SAPPriceList", {code: code})
        		.then(response => {
        			if(response.data != 0){
		      			this.SAPItems = response.data;
		      			toast.fire({
		      				icon: "success",
		      				title: "Search Complete"
		      			});
		      			$("#icantthinkofaname").modal("show");
		      			$("#searchitemsmodal").modal("hide");
		      			$("#itemsModal").modal("hide");
		      		}
		      		else
		      			toast.fire({
		      				icon: "success",
		      				title: "No Items"
		      			});
        			this.search_status = 'Search Complete!';
        			this.lshow = false;
        		})
        		.catch((error) => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
        			this.search_status = 'Search Complete!';
        			this.lshow = false;
        		})
        	},

        	addItem(item){
        		item.RequestedQuantity = 1;
        		item.Notes = "";
        		this.items.push(item);
        		$("#icantthinkofaname").modal("hide");
        	},

            deleteTransferItem(index) {
                this.items.splice(index, 1);
            },

        	increment(index){
        		console.log("index "+index);
        		console.log("curr "+this.items[index].RequestedQuantity);
        		console.log("increment "+(parseInt(this.items[index].RequestedQuantity)+parseInt(1)));

        		this.items[index].RequestedQuantity = parseInt(this.items[index].RequestedQuantity)+parseInt(1);
        		console.log("updated "+this.items[index].RequestedQuantity);
        	},

        	decrement(index){
        		console.log("index "+index);
        		console.log("curr "+this.items[index].RequestedQuantity);
        		console.log("increment "+(parseInt(this.items[index].RequestedQuantity)+parseInt(1)));

        		this.items[index].RequestedQuantity = parseInt(this.items[index].RequestedQuantity)+parseInt(1);
        		console.log("updated "+this.items[index].RequestedQuantity);
        	},

        	addPrompt(){
        		$("#searchModal").modal("show");
        	},

        	requestTransfer(){
        		axios.post("/api/preApprovedStockTransferRequest", {destination_branch: this.destination_branch, destination_warehouse: this.destination_warehouse, source_warehouse: this.source_warehouse, source_branch: this.source_branch, items: this.items, notes: this.notes})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Request Made'
        			});
        		})
        	}
        }
    }
</script>
